import { IGroupedComboBoxStyles, IGroupedComboBoxStyleProps } from './GroupedComboBox.types';

const defaultComboBoxWidth = 160;

export const getStyles = (props: IGroupedComboBoxStyleProps): IGroupedComboBoxStyles => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: props.width ?? defaultComboBoxWidth,
    },
    subComponentStyles: {
        textFieldStyles: {
            root: {
                height: '100%',
            },
            textInput: {},
            prefix: {},
        },
        dropDownStyles: {},
    },
});
